// Central translations dictionary for UPPOWER SOLAR CRM.
// Numerics are intentionally NOT translated.
export const DICT = {
    en: {
        // Common
        app_name: 'UPPOWER SOLAR',
        app_tagline: 'Energising Uttar Pradesh',
        language_english: 'English',
        language_hindi: 'हिंदी',
        customer: 'Customer',
        admin: 'Admin',
        staff: 'Staff',
        login: 'Login',
        signup: 'Signup',
        logout: 'Logout',
        home: 'Home',
        apply: 'Apply',
        applications: 'Applications',
        my_applications: 'My Applications',
        new_application: 'New Application',
        support: 'Support',
        profile: 'Profile',
        complaints: 'Complaints',
        subsidy: 'Subsidy',
        subsidy_calculator: 'Subsidy Calculator',
        quick_links: 'Quick Links',
        vendors: 'Vendors',
        vendor_chat: 'Vendor Chat',
        ai_chat: 'AI Chat',
        solar_info: 'Solar Info',
        quotations: 'Quotations',
        refer_earn: 'Refer & Earn',
        site_survey: 'Book Saathi Survey',
        generation_log: 'Generation Log',
        dashboard: 'Dashboard',
        leads: 'Leads',
        applications_admin: 'Applications',
        site_surveys_admin: 'Site Surveys',
        site_surveys_and_visits: 'Survey Visits',
        my_wallet: 'My Wallet',
        vendors_admin: 'Vendors',
        customers_admin: 'Customers',
        staff_roles: 'Staff & Roles',
        referrals: 'Referrals',
        subsidy_rates: 'Subsidy Rates',
        content_admin: 'Content',
        notifications: 'Notifications',
        view_messages: 'View Messages',
        whatsapp_inbox: 'WhatsApp Inbox',
        nerochat_logs: 'Nerochat API Logs',
        saathi_kicker: 'Your Trusted Partner',
        saathi_title_1: 'Your "Solar Saathi"',
        saathi_title_2: 'Always With You',
        saathi_body: 'Installing solar is no longer difficult. Our dedicated "Solar Saathi" comes to your home and helps at every step — from registration to receiving subsidy.',
        saathi_b1: 'Free documentation support',
        saathi_b2: 'On-site technical survey',
        saathi_b3: 'Full net-metering assistance',
        saathi_paperwork: 'Paperwork',
        saathi_paperwork_d: 'Leave the government paperwork to us — we handle everything.',
        saathi_maint: 'Maintenance',
        saathi_maint_d: 'After installation we stay ready for service whenever you need us.',
        saathi_finance: 'Bank Finance',
        saathi_finance_d: 'Complete loan support to install solar on easy EMIs.',
        saathi_install: 'Correct Installation',
        saathi_install_d: 'Systems fitted to the highest standards by trained engineers.',
        saathi_book_cta: 'Book Solar Saathi Visit',
        saathi_book_title: 'Book a Solar Saathi Home Visit',
        saathi_book_sub: 'Our Solar Saathi will visit your home for a free rooftop survey and guide you through the subsidy process.',
        saathi_book_address: 'Address',
        saathi_book_date: 'Preferred date',
        saathi_book_slot: 'Preferred slot',
        saathi_slot_morning: 'Morning (9 – 12)',
        saathi_slot_afternoon: 'Afternoon (12 – 4)',
        saathi_slot_evening: 'Evening (4 – 7)',
        saathi_book_submit: 'Confirm Home Visit',
        bank_kicker: 'Easy Financing',
        bank_title: 'Solar Loans From Trusted Banks',
        bank_sub: 'Zero-down solar with easy EMIs. Pre-approved partner tie-ups — apply in minutes.',
        bank_perk_1: '0% down payment options',
        bank_perk_2: 'Tenure up to 10 years',
        bank_perk_3: 'Full documentation help',
        bank_cta: 'Check My EMI Eligibility',
        attendance: 'Attendance',
        attendance_summary: 'Attendance Report',
        staff_tracking: 'Live Staff Tracking',
        products: 'Product Catalog',
        payments_report: 'Payments Report',
        login_events: 'Login & Security',
        push_console: 'Push Console',
        broadcast_news: 'Broadcast News',
        hierarchy: 'User Hierarchy',
        my_team: 'My Team',
        my_attendance_history: 'My Attendance History',
        saathi_bookings: 'Visits & Surveys',
        my_attendance: 'My Attendance',
        punch_in: 'Punch In',
        punch_out: 'Punch Out',
        nav_home: 'Home',
        nav_about: 'About Us',
        nav_solar_types: 'Solar Types',
        nav_offering: 'Our Offering',
        nav_faq: 'FAQ',
        nav_careers: 'Careers',
        nav_contact: 'Contact',
        get_free_quote: 'Get Free Quote',
        ongrid_title: 'On-Grid Solar',
        ongrid_desc: 'Connected to the electricity grid. Export surplus power and earn via net-metering. Best for homes with regular grid supply.',
        offgrid_title: 'Off-Grid Solar',
        offgrid_desc: 'Battery-based, fully independent of the grid. Perfect for areas with frequent outages or remote locations.',
        hybrid_title: 'Hybrid Solar',
        hybrid_desc: 'Best of both worlds — grid-tied with battery backup. Power flows to grid when full and to battery when needed.',
        // Landing/business/quote form
        quote_your_name: 'Your Name',
        quote_your_mobile: 'Your Mobile',
        quote_capacity: 'Approx capacity (kW)',
        quote_type: 'System Type',
        quote_property: 'Property Type',
        quote_message: 'Message',
        quote_submit: 'Request FREE Quote',
        quote_success: 'Thanks! Our team will call you shortly.',
        // Landing
        cta_apply_now: 'Apply Now',
        cta_check_status: 'Check Status',
        cta_free_consultation: 'Get FREE Consultation',
        landing_h1_a: 'Freedom from Electricity Bills.',
        landing_h1_b: 'Every Home a Power House.',
        landing_sub: 'Just ₹1 booking — Easy EMI + ₹1,08,000 subsidy. Free rooftop survey, hassle-free installation, and 25 years of free electricity!',
        landing_scheme_badge: 'Pradhan Mantri Surya Ghar • Muft Bijli Yojana',
        landing_get_solar_for: 'Get Solar for',
        landing_homes: 'Homes',
        landing_homes_desc: 'Save up to 90% on your home electricity bills.',
        landing_society: 'Housing Societies',
        landing_society_desc: 'Reduce common-area power costs and add long-term value.',
        landing_commercial: 'Commercial',
        landing_commercial_desc: 'Power your business with green energy and save costs.',
        landing_why_us: 'Why Families Across UP Trust UPPOWER',
        landing_guaranteed_subsidy: 'Guaranteed Subsidy',
        landing_guaranteed_subsidy_desc: 'Government subsidy up to ₹1,08,000 — we handle all paperwork end-to-end.',
        landing_hassle_free: 'Hassle-free Process',
        landing_hassle_free_desc: 'Installation, subsidy & service — handled directly by us. Zero middlemen.',
        landing_storm_proof: 'Storm-proof Mounting',
        landing_storm_proof_desc: '170 kmph wind-tested structures. Built for Indian weather.',
        landing_amc: '5-Year AMC',
        landing_amc_desc: 'Regular maintenance visits included — you save, we maintain.',
        landing_rate_chart: 'ONGRID Solar Rate Chart',
        landing_rate_sub: 'Government subsidy based on system capacity',
        col_capacity: 'Capacity (KW)',
        col_system_cost: 'System Cost (₹)',
        col_subsidy: 'Subsidy (₹)',
        col_your_cost: 'Your Cost (₹)',
        landing_journey: 'We Handle Everything. You Just Save.',
        step_1: 'Free Home Visit',
        step_1_desc: 'Our team visits your home to measure the rooftop — completely free.',
        step_2: 'Personalised Design',
        step_2_desc: 'Custom solar design & quotation prepared for your roof.',
        step_3: 'Installation & Subsidy',
        step_3_desc: 'We handle both installation and subsidy paperwork.',
        step_4: 'You Save, We Maintain',
        step_4_desc: 'Savings start from day 1, and we cover 5-year AMC.',
        landing_faq: 'Frequently Asked Questions',
        faq_1_q: 'Do I need to pay a huge amount upfront?',
        faq_1_a: 'No. You can go solar with flexible EMIs. The government subsidy covers your down payment, and bill savings often cover the EMI. You only need to book with ₹1.',
        faq_2_q: 'How complicated is the subsidy process?',
        faq_2_a: 'You only need to share documents; we manage all paperwork. Subsidy is credited directly to your bank via DBT.',
        faq_3_q: 'How long does installation take?',
        faq_3_a: 'After site inspection, typically 1 day for installation (depends on roof size and weather).',
        faq_4_q: 'What is the lifespan of a rooftop solar system?',
        faq_4_a: 'Panels last 25 years or more. We include 5-year AMC free.',
        faq_5_q: 'Do solar panels work during monsoon and winter?',
        faq_5_a: 'Yes, though efficiency is slightly reduced. This is already factored into generation estimates.',
        landing_helpline: 'Helpline',
        landing_corp_office: 'Corporate Office',
        landing_reg_office: 'Registered Office',
        landing_footer_note: 'Made with Love in India',
        rated: 'Trusted by families across UP',
        // Home
        namaste: 'Namaste',
        quick_actions: 'Services',
        apply_pm_surya_ghar: 'Apply for PM Surya Ghar',
        ask_surya_mitra: 'Ask Surya Mitra AI',
        view_all: 'View all',
        no_apps_yet: 'No applications yet. Start your PM Surya Ghar application.',
        no_complaints_yet: 'No complaints. Any issue with your solar system? Raise a complaint.',
        // Refer
        your_referral_code: 'Your referral code',
        share_link_hint: 'Share this link with friends',
        copy: 'Copy',
        copied: 'Copied',
        share_whatsapp: 'Share on WhatsApp',
        total_referrals: 'Total Referrals',
        converted: 'Converted',
        approved_unpaid: 'Approved (unpaid)',
        earned_paid: 'Earned (paid)',
        my_referrals: 'My Referrals',
        add_referral: 'Add Referral Manually',
        // Common form
        save: 'Save',
        cancel: 'Cancel',
        edit: 'Edit',
        "delete": 'Delete',
        create: 'Create',
        submit: 'Submit',
        name: 'Name',
        email: 'Email',
        mobile: 'Mobile',
        // eslint-disable-next-line -- i18n label only; NOT a secret. Static analysers sometimes flag this.
        password: 'Password',
        city: 'City',
        district: 'District',
        address: 'Address',
        status: 'Status',
        notes: 'Notes',
        remark: 'Remark',
        remarks_history: 'Remarks History',
        add_remark: 'Save Remark',
    },
    hi: {
        app_name: 'UPPOWER SOLAR',
        app_tagline: 'उत्तर प्रदेश को ऊर्जा से सशक्त',
        language_english: 'English',
        language_hindi: 'हिन्दी',
        customer: 'ग्राहक',
        admin: 'एडमिन',
        staff: 'स्टाफ़',
        login: 'लॉगिन',
        signup: 'रजिस्टर',
        logout: 'लॉगआउट',
        home: 'होम',
        apply: 'आवेदन करें',
        applications: 'आवेदन',
        my_applications: 'मेरे आवेदन',
        new_application: 'नया आवेदन',
        support: 'सहायता',
        profile: 'प्रोफ़ाइल',
        complaints: 'शिकायतें',
        subsidy: 'सब्सिडी',
        subsidy_calculator: 'सब्सिडी कैल्कुलेटर',
        quick_links: 'जरूरी लिंक',
        vendors: 'वेंडर',
        vendor_chat: 'वेंडर चैट',
        ai_chat: 'एआई चैट',
        solar_info: 'जानकारी',
        quotations: 'कोटेशन',
        refer_earn: 'रेफर & कमाएं',
        site_survey: 'साथी सर्वे बुक करें',
        generation_log: 'बिजली उत्पादन',
        dashboard: 'डैशबोर्ड',
        leads: 'लीड्स',
        applications_admin: 'आवेदन',
        site_surveys_admin: 'साइट सर्वे',
        site_surveys_and_visits: 'सर्वे और विज़िट',
        my_wallet: 'मेरा वॉलेट',
        vendors_admin: 'वेंडर',
        customers_admin: 'ग्राहक',
        staff_roles: 'स्टाफ़ और रोल',
        referrals: 'रेफरल',
        subsidy_rates: 'सब्सिडी दरें',
        content_admin: 'कंटेंट',
        notifications: 'नोटिफिकेशन',
        view_messages: 'भेजे गए संदेश',
        whatsapp_inbox: 'WhatsApp इनबॉक्स',
        nerochat_logs: 'Nerochat API लॉग्स',
        saathi_kicker: 'आपका भरोसेमंद साथी',
        saathi_title_1: 'आपका "सोलर साथी"',
        saathi_title_2: 'हमेशा आपके साथ',
        saathi_body: 'सोलर लगवाना अब कठिन नहीं। हमारा समर्पित "सोलर साथी" रजिस्ट्रेशन से लेकर सब्सिडी मिलने तक हर कदम पर आपके घर आकर आपकी मदद करेगा।',
        saathi_b1: 'फ्री डॉक्यूमेंटेशन सहायता',
        saathi_b2: 'ऑन-साइट टेक्निकल सर्वे',
        saathi_b3: 'नेट-मीटरिंग में पूर्ण सहयोग',
        saathi_paperwork: 'पेपर वर्क',
        saathi_paperwork_d: 'सरकारी कागज़ी कार्रवाई की चिंता छोड़ें, हम सब संभाल लेंगे।',
        saathi_maint: 'मैन्टेनेंस',
        saathi_maint_d: 'सिस्टम लग जाने के बाद भी हम सर्विस के लिए हाजिर रहेंगे।',
        saathi_finance: 'बैंक फाइनेंस',
        saathi_finance_d: 'आसान किस्तों (EMI) पर सोलर लगवाने के लिए पूरी लोन सहायता।',
        saathi_install: 'सही इंस्टालेशन',
        saathi_install_d: 'कुशल इंजीनियरों द्वारा उच्चतम मानकों पर सिस्टम फिटिंग।',
        saathi_book_cta: 'सोलर साथी विज़िट बुक करें',
        saathi_book_title: 'सोलर साथी होम विज़िट बुक करें',
        saathi_book_sub: 'हमारा सोलर साथी आपके घर आकर मुफ्त रूफटॉप सर्वे करेगा और सब्सिडी प्रक्रिया में मदद करेगा।',
        saathi_book_address: 'पता',
        saathi_book_date: 'पसंदीदा तारीख',
        saathi_book_slot: 'पसंदीदा समय',
        saathi_slot_morning: 'सुबह (9 – 12)',
        saathi_slot_afternoon: 'दोपहर (12 – 4)',
        saathi_slot_evening: 'शाम (4 – 7)',
        saathi_book_submit: 'होम विज़िट कन्फर्म करें',
        bank_kicker: 'आसान लोन',
        bank_title: 'भरोसेमंद बैंकों से सोलर लोन',
        bank_sub: 'बिना डाउन-पेमेंट के सोलर, आसान EMI पर। पार्टनर बैंक से मिनटों में अप्रूवल।',
        bank_perk_1: '0% डाउन पेमेंट विकल्प',
        bank_perk_2: '10 साल तक की अवधि',
        bank_perk_3: 'पूरी डॉक्युमेंटेशन सहायता',
        bank_cta: 'मेरी EMI योग्यता जाँचें',
        attendance: 'अटेंडेंस',
        attendance_summary: 'अटेंडेंस रिपोर्ट',
        staff_tracking: 'लाइव स्टाफ ट्रैकिंग',
        products: 'प्रोडक्ट कैटलॉग',
        payments_report: 'पेमेंट्स रिपोर्ट',
        login_events: 'लॉगिन और सुरक्षा',
        push_console: 'पुश कंसोल',
        broadcast_news: 'ब्रॉडकास्ट न्यूज़',
        hierarchy: 'रिपोर्टिंग ट्री',
        my_team: 'मेरी टीम',
        my_attendance_history: 'मेरी अटेंडेंस हिस्ट्री',
        saathi_bookings: 'साथी विज़िट',
        my_attendance: 'मेरी अटेंडेंस',
        punch_in: 'पंच इन',
        punch_out: 'पंच आउट',
        nav_home: 'होम',
        nav_about: 'हमारे बारे में',
        nav_solar_types: 'सोलर प्रकार',
        nav_offering: 'हमारी सर्विसेज़',
        nav_faq: 'सवाल-जवाब',
        nav_careers: 'करियर',
        nav_contact: 'संपर्क',
        get_free_quote: 'फ्री कोटेशन पाएं',
        ongrid_title: 'ऑन-ग्रिड सोलर',
        ongrid_desc: 'बिजली ग्रिड से जुड़ा हुआ। अतिरिक्त बिजली नेट-मीटरिंग से बेचकर कमाई करें। रेगुलर ग्रिड सप्लाई वाले घरों के लिए बेस्ट।',
        offgrid_title: 'ऑफ-ग्रिड सोलर',
        offgrid_desc: 'बैटरी वाला सिस्टम, ग्रिड से पूरी तरह स्वतंत्र। कटौती वाले या दूरदराज़ इलाकों के लिए बेहतरीन।',
        hybrid_title: 'हाइब्रिड सोलर',
        hybrid_desc: 'ग्रिड और बैटरी दोनों का फायदा — पूरी होने पर ग्रिड में भेजें, ज़रूरत पर बैटरी से चलाएं।',
        quote_your_name: 'आपका नाम',
        quote_your_mobile: 'मोबाइल नंबर',
        quote_capacity: 'अनुमानित क्षमता (kW)',
        quote_type: 'सिस्टम टाइप',
        quote_property: 'प्रॉपर्टी टाइप',
        quote_message: 'संदेश',
        quote_submit: 'फ्री कोटेशन पाएं',
        quote_success: 'धन्यवाद! हमारी टीम जल्द ही कॉल करेगी।',
        cta_apply_now: 'आवेदन करें',
        cta_check_status: 'स्थिति देखें',
        cta_free_consultation: 'FREE सलाह पाएं',
        landing_h1_a: 'बिजली बिल से आज़ादी,',
        landing_h1_b: 'अब हर घर बनेगा पावर हाउस',
        landing_sub: 'मात्र ₹1 बुकिंग — आसान EMI + ₹1,08,000 तक सब्सिडी। फ्री छत सर्वे, बिना झंझट इंस्टॉलेशन, और 25 साल तक मुफ्त बिजली!',
        landing_scheme_badge: 'प्रधानमंत्री सूर्य घर • मुफ्त बिजली योजना',
        landing_get_solar_for: 'सोलर किसके लिए?',
        landing_homes: 'घर',
        landing_homes_desc: 'आपने बिजली बिल में 90% तक बचत करें।',
        landing_society: 'सोसायटी',
        landing_society_desc: 'कॉमन एरिया में बिजली खर्च घटाएं और सोसायटी की वैल्यू बढ़ाएं।',
        landing_commercial: 'व्यवसाय',
        landing_commercial_desc: 'ग्रीन ऊर्जा से अपना बिज़नेस चलाएं और खर्च बचाएं।',
        landing_why_us: 'यूपी के परिवार UPPOWER पर क्यों भरोसा करते हैं',
        landing_guaranteed_subsidy: 'गेरंटीड सब्सिडी',
        landing_guaranteed_subsidy_desc: 'सरकारी सब्सिडी ₹1,08,000 तक — पूरा पेपरवर्क हम संभालते हैं।',
        landing_hassle_free: 'बिना झंझट',
        landing_hassle_free_desc: 'इंस्टॉलेशन, सब्सिडी और सर्विस — सब कुछ सीधे हमसे। कोई बिचौलिया नहीं।',
        landing_storm_proof: 'तूफान-रोधी डिज़ाइन',
        landing_storm_proof_desc: '170 kmph हवा टेस्टेड — भारतीय मौसम के लिए बनाया गया।',
        landing_amc: '5 साल फ्री AMC',
        landing_amc_desc: 'नियमित मेंटेनेंस — आप बचत करें, हम संभालेंगे।',
        landing_rate_chart: 'ONGRID सोलर रेट चार्ट',
        landing_rate_sub: 'क्षमता के अनुसार सरकारी सब्सिडी',
        col_capacity: 'क्षमता (KW)',
        col_system_cost: 'सिस्टम की कीमत (₹)',
        col_subsidy: 'सब्सिडी (₹)',
        col_your_cost: 'आपकी लागत (₹)',
        landing_journey: 'सबकुछ हम संभालेंगे, आप सिर्फ़ बचत करें',
        step_1: 'फ्री घर विज़िट',
        step_1_desc: 'हमारी टीम आपके घर आकर छत मापती है — बिल्कुल फ्री।',
        step_2: 'सोलर डिजाइन',
        step_2_desc: 'आपकी छत के अनुसार custom design और कोटेशन।',
        step_3: 'इंस्टॉलेशन & सब्सिडी',
        step_3_desc: 'installation और सब्सिडी का paperwork — दोनों हम करते हैं।',
        step_4: 'आप बचत करें, हम संभालें',
        step_4_desc: 'Day 1 से सेविंग शुरू, 5-year AMC included।',
        landing_faq: 'आम प्रश्न',
        faq_1_q: 'क्या मुझे बड़ी रकम एकसाथ देनी होगी?',
        faq_1_a: 'नहीं। आप आसान EMI से सोलर ले सकते हैं। सरकारी सब्सिडी आपकी down payment cover कर लेती है, और bill savings से EMI निकल आती है। आपको सिर्फ़ ₹1 में बुकिंग करनी है।',
        faq_2_q: 'सब्सिडी का process कितना मुश्किल है?',
        faq_2_a: 'आप सिर्फ़ documents दीजिए, बाकी सब कुछ हम संभालते हैं। सब्सिडी DBT से सीधे आपके बैंक में आती है।',
        faq_3_q: 'Installation में कितना time लगता है?',
        faq_3_a: 'Site inspection के बाद, आमतौर पर 1 दिन में installation हो जाता है (roof size और मौसम पर निर्भर)।',
        faq_4_q: 'सोलर सिस्टम कितने साल चलता है?',
        faq_4_a: 'Panels 25 साल या उससे ज़्यादा चलते हैं। 5-year AMC फ्री शामिल है।',
        faq_5_q: 'क्या बारिश और सर्दियों में भी बिजली बनती है?',
        faq_5_a: 'हाँ, लेकिन efficiency थोड़ी कम होती है। ये estimate में पहले से ले लिया जाता है।',
        landing_helpline: 'हेल्पलाइन',
        landing_corp_office: 'कॉर्पोरेट ऑफ़िस',
        landing_reg_office: 'पंजीकृत कार्यालय',
        landing_footer_note: 'Made with Love in India',
        rated: 'यूपी के परिवारों का भरोसा',
        namaste: 'नमस्ते',
        quick_actions: 'सेवाएँ',
        apply_pm_surya_ghar: 'PM सूर्य घर में आवेदन करें',
        ask_surya_mitra: 'सूर्य मित्र AI से पूछें',
        view_all: 'सब देखें',
        no_apps_yet: 'अभी कोई आवेदन नहीं। PM सूर्य घर योजना में आवेदन शुरू करें।',
        no_complaints_yet: 'कोई शिकायत नहीं। सोलर में कोई परेशानी है? शिकायत दर्ज करें।',
        your_referral_code: 'आपका रेफरल कोड',
        share_link_hint: 'यह लिंक दोस्तों के साथ शेयर करें',
        copy: 'कॉपी',
        copied: 'कॉपी हो गया',
        share_whatsapp: 'WhatsApp पर शेयर',
        total_referrals: 'कुल रेफरल',
        converted: 'कनवर्ट',
        approved_unpaid: 'अप्रूव्ड (अनपेभ)',
        earned_paid: 'कमाई (पेफ)',
        my_referrals: 'मेरे रेफरल',
        add_referral: 'रेफरल जोड़ें',
        save: 'सेव करें',
        cancel: 'रद्द',
        edit: 'एडिट',
        "delete": 'डिलीट',
        create: 'बनाएं',
        submit: 'सबमिट',
        name: 'नाम',
        email: 'ईमेल',
        mobile: 'मोबाइल',
        password: 'पासवर्ड',
        city: 'शहर',
        district: 'जिला',
        address: 'पता',
        status: 'स्थिति',
        notes: 'टिप्पणी',
        remark: 'टिप्पणी',
        remarks_history: 'टिप्पणी इतिहास',
        add_remark: 'टिप्पणी जोड़ें',
    },
};
